let n;
const e = (t) => {
  n = t;
}, s = () => n;
export {
  s as getI18n,
  e as setI18n
};
//# sourceMappingURL=help-center-knowledge-anatomies42.js.map
